import { headerStyles as styles } from "@iewccouk/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { mediaQueriesBP } from "@iewccouk/Utilities/variables";
import { css } from "styled-components";

styles.headerGridContainer = {
    ...styles.headerGridContainer,
    gap: 10,
    css: css`
        ${styles.headerGridContainer?.css}
        margin-bottom: 30px;
    `,
};

styles.titleGridItem = {
    ...styles.titleGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
};

styles.title = {
    ...styles.title,
    css: css`
        ${styles.title.css}
        margin-bottom: 0;
    `,
};

styles.buttonGridItem = {
    ...styles.buttonGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
    css: css`
        ${styles.buttonGridItem?.css}

        ${mediaQueriesBP.maxMD} {
            justify-content: flex-start;
        }
    `,
};
